module.exports = __webpack_public_path__ + "static/img/horror-hand-v6.c6763246.png";